import {
  MdDashboard,
  MdBarChart,
  MdPersonAdd,
  MdManageAccounts,
  MdHistory,
  MdPayments,
  MdToday,
  MdSettingsBackupRestore,
  MdAssignmentReturn,
  MdMonetizationOn,
  MdAddShoppingCart,
  MdInventory,
  MdArchive,
  MdErrorOutline,
  MdDirectionsCarFilled,
  MdSettings,
  MdEventNote,
  MdFolderZip,
  MdLocalOffer,
  MdPostAdd,
  MdInventory2,
  MdLocalGasStation,
  MdAttachMoney
} from "react-icons/md";
import { BiSolidUser } from "react-icons/bi";
import { IoCardSharp } from "react-icons/io5";
import { FaDropbox } from "react-icons/fa";
import { GiCarWheel } from "react-icons/gi";
import { MdSell } from "react-icons/md";

export const menus = {
  admin: [
    {
      title: "Əsas Panel",
      icon: MdDashboard,
      subItems: [
        { title: "Satış statistikası", path: "sales-statistics", icon: MdBarChart }
      ]
    },
    {
      title: "İşçilər",
      icon: BiSolidUser,
      subItems: [
        { title: "Yeni işçi", path: "new-employee", icon: MdPersonAdd },
        { title: "İşçilərin idarə edilməsi", path: "manage-employees", icon: MdManageAccounts },
        { title: "İşçi logları", path: "employee-logs", icon: MdHistory }
      ]
    },
    {
      title: "Ödə­mə­lər",
      icon: IoCardSharp,
      subItems: [
        { title: "Ümumi ödənişlər", path: "total-payments", icon: MdPayments },
        { title: "Bugünkü satışlar", path: "today-sales", icon: MdToday },
        { title: "Geri qaytarma", path: "refund", icon: MdSettingsBackupRestore },
        { title: "Geri qaytarmalar", path: "refunded-sales", icon: MdAssignmentReturn },
        { title: "Ümumi qazanclar", path: "total-earnings", icon: MdMonetizationOn },
        { title: "Xərclər", path: "expenses", icon: MdAttachMoney }
      ]
    },
    {
      title: "Məhsullar",
      icon: FaDropbox,
      subItems: [
        { title: "Məhsul əlavə et", path: "add-product", icon: MdAddShoppingCart },
        { title: "Məhsulların idarə edilməsi", path: "manage-products", icon: MdInventory },
        { title: "Arxivləşdirilmiş məhsullar", path: "archived-products", icon: MdArchive },
        { title: "Tükənmiş məhsullar", path: "out-of-stock-products", icon: MdErrorOutline }
      ]
    },
    {
      title: "Maşın dəyişiklikləri",
      icon: GiCarWheel,
      subItems: [
        { title: "Maşın əlavə et", path: "add-car", icon: MdDirectionsCarFilled },
        { title: "Maşınların idarə edilməsi", path: "manage-cars", icon: MdSettings },
        { title: "Dəyişiklik qeydləri", path: "change-logs", icon: MdEventNote },
        { title: "Arxivləşdirilmiş maşınlar", path: "archived-cars", icon: MdFolderZip },
        { title: "Qiymət endirimi", path: "price-discount", icon: MdLocalOffer },
        { title: "Yağ tələbləri", path: "oil-requirements", icon: MdLocalGasStation }
      ]
    }
  ],

  seller: [
    {
      title: "Satış İdarəetməsi",
      icon: MdSell,
      subItems: [
        { title: "Satış Əlavə Et", path: "add-sale", icon: MdPostAdd },
        { title: "Geri qaytarma", path: "refund", icon: MdSettingsBackupRestore },
        { title: "Geri qaytarmalar", path: "refunded-sales", icon: MdAssignmentReturn }
      ]
    },
    {
      title: "Məhsullar",
      icon: FaDropbox,
      subItems: [
        { title: "Stok Məlumatı", path: "stock-info", icon: MdInventory2 }
      ]
    },
    {
      title: "Maşın dəyişiklikləri",
      icon: GiCarWheel,
      subItems: [
        { title: "Maşın əlavə et", path: "add-car", icon: MdDirectionsCarFilled },
        { title: "Maşınların idarə edilməsi", path: "manage-cars", icon: MdSettings },
        { title: "Dəyişiklik qeydləri", path: "change-logs", icon: MdEventNote },
        { title: "Arxivləşdirilmiş maşınlar", path: "archived-cars", icon: MdFolderZip },
        { title: "Qiymət endirimi", path: "price-discount", icon: MdLocalOffer }
      ]
    }
  ]
};
